<style lang='scss' scoped>
.userinfo {
    padding: 0 !important;
    cursor: pointer;
    &-title {
        height: 100%;
        display: inline-flex;
        align-items: center;
        padding: 0 6px;
    }
    &:hover {
        .userinfo-title {
            color: #4093ff;
            background-color: #09659A;
        }
        .nav-items {
            display: block;
        }
    }
}
.nav-avatar {
    border-radius: 9999px;
    width: 29px;
    height: 29px;
    margin-right: 5px;
}
.nav-items {
    display: none;
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 1000;
    line-height: 36px;
    min-width: 100%;
    white-space: nowrap;
    background-color: #09659A;
    box-shadow: 0 0 2px #ccc;
    a {
        display: block;
        padding: 0 20px;
        color: inherit;
        &:hover {
            color: #4093ff;
            background-color: #09659A;
        }
    }
}
</style>


<template>
	<aside class="userinfo" v-show="info">
		<div class="userinfo-title">
			<img src="../../../image/avatar.jpg" class="nav-avatar" />
			<span>{{info}}&nbsp;</span>
			<vIcon type="arrow-dropdown"></vIcon>
		</div>
		<div class="nav-items">
			<a v-for="item in getProjects" :href="item.url" target="_blank">{{item.title}}</a>
            <!-- <a @click="clickshowtab()">{{showCliTab=='true' ? $t('global.common.close', { defaultValue: '关闭' }) : $t('global.common.open', { defaultValue: '打开' }) }}{{$t('global.common.muti_items', { defaultValue: '多标签模式' })}}</a> -->
			<a @click="logout(false)">{{$t('global.common.signout')}}</a>
		</div>
	</aside>
</template>

<script>
import Cookies from 'js-cookie'
import { mapState } from 'vuex';
import { LogoutBase } from '../../../service/base';
export default {
	data() {
		return {
            showCliTab:Cookies.get("showtab") || 'false',
		};
    },
	methods: {
        logout:LogoutBase,
        clickshowtab(){
            console.log(this.showCliTab,Cookies.get("showtab"))
            this.bus.$emit("changeshowtab", Cookies.get("showtab") || 'false');
            // this.showCliTab = Cookies.get("showtab");
            if (Cookies.get("showtab") === 'true') {Cookies.set('showtab', 'false', { domain: global.DOMAIN, expires: 7 });this.showCliTab = 'false';}
            else { Cookies.set('showtab', 'true', { domain: global.DOMAIN, expires: 7 });this.showCliTab = 'true';}
        }
	},
	computed: {
		...mapState(['userinfo']),
		// ...mapState('layout', ['sysScopeList']),
		getProjects() {
			const prefix = global.envPrefix;
			return [{
				url: this.handleHostname(`https://${prefix}port.onepinnovate.com/home/panel`),
				title: this.$t('global.common.panel')
			}, {
				url:  this.handleHostname(`https://${prefix}port.onepinnovate.com/home/profile`),
				title: this.$t('global.common.profile', { defaultValue: '我的资料' })
			}, {
				url:  this.handleHostname(`https://${prefix}port.onepinnovate.com/home/password`),
				title: this.$t('global.common.password', { defaultValue: '修改密码' })
			}, {
				url:  this.handleHostname(`https://${prefix}uc-adm.onepinnovate.com/`),
				title: this.$t('global.common.ucadm_title', { defaultValue: '用户管理中心' })
			}, {
				url:  this.handleHostname(`https://${prefix}boss.onepinnovate.com/home`),
				title: this.$t('global.common.erp_title', { defaultValue: 'Boss 子系统' })
			}]
		},
		info() {
            if (this.userinfo.email[0] === '#') return this.userinfo.phone
			return this.userinfo.email
        },
	},
};
</script>
